import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type TrialDrivesQueryVariables = Types.Exact<{
  userGroupId: Types.Scalars['String'];
}>;


export type TrialDrivesQuery = { __typename?: 'QueryRoot', trialDrives: Array<{ __typename?: 'TrialDrive', trialDriveId: string, name: string }> };


export const TrialDrivesDocument = gql`
    query TrialDrives($userGroupId: String!) {
  trialDrives(userGroupId: $userGroupId) {
    trialDriveId
    name
  }
}
    `;

export function useTrialDrivesQuery(options: Omit<Urql.UseQueryArgs<TrialDrivesQueryVariables>, 'query'>) {
  return Urql.useQuery<TrialDrivesQuery, TrialDrivesQueryVariables>({ query: TrialDrivesDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrialDrivesQuery((req, res, ctx) => {
 *   const { userGroupId } = req.variables;
 *   return res(
 *     ctx.data({ trialDrives })
 *   )
 * })
 */
export const mockTrialDrivesQuery = (resolver: ResponseResolver<GraphQLRequest<TrialDrivesQueryVariables>, GraphQLContext<TrialDrivesQuery>, any>) =>
  graphql.query<TrialDrivesQuery, TrialDrivesQueryVariables>(
    'TrialDrives',
    resolver
  )
